
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import AnimateInView from '@/components/ui/animate-in-view';
interface HeroProps {
  backgroundImage?: string;
  backgroundVideo?: string;
  isVideoActive?: boolean; // New prop to control video vs. image
}

/**
 * @component Hero
 * @description Main hero section for the homepage with background image and CTA buttons
 * @returns {JSX.Element} Hero section with refined styling
 */
const Hero: React.FC<HeroProps> = ({
  backgroundImage = "/images/hero-section-home-page-2.png", // Default background image
  backgroundVideo,
  isVideoActive = true // Default to static image if not specified
}) => {
  return <>
      <section 
        className="relative min-h-[90vh] flex items-center hero-section" 
        style={{
          // Apply backgroundImage to the section if video is not active,
          // or if video is active but no video source is provided (acting as a fallback),
          // AND a backgroundImage is available.
          ...((!isVideoActive || (isVideoActive && !backgroundVideo)) && backgroundImage && {
              backgroundImage: `url('${backgroundImage}')`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat',
            }
          )
        }}
        aria-labelledby="hero-heading"
      >
        {isVideoActive && backgroundVideo && (
          <video
            autoPlay
            loop
            muted
            playsInline // Important for iOS to play inline
            poster={backgroundImage} // Use backgroundImage as the poster
            className="absolute top-0 left-0 w-full h-full object-cover z-0"
          >
            <source src={backgroundVideo} type="video/mp4" />
            Your browser does not support the video tag. 
          </video>
        )}
        
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-20">
          <div className="max-w-3xl">
            <div className="space-y-8">
              <AnimateInView animation="fade-in" className="block">
                <h1 id="hero-heading" className="text-5xl sm:text-6xl lg:text-7xl font-serif font-light tracking-tight">
                  <span className="block text-white">Invisible.</span>
                  <span className="block text-gold">Uncompromising.</span>
                </h1>
              </AnimateInView>
              
              <AnimateInView animation="fade-in" delay={200} className="block">
                <p className="text-xl md:text-2xl text-white/95 mt-6 max-w-xl font-light">
                  Forti-Fi Fiber Optic & On-Fence Solutions: Discreet, Intelligent, Unmatched Protection.
                </p>
              </AnimateInView>
              
              <AnimateInView animation="fade-in" delay={400} className="block">
                <div className="mt-10 flex flex-wrap gap-5">
                  <Button asChild size="xl" variant="gradient" className="text-white">
                    <Link to="/contact">
                      Request Private Briefing
                    </Link>
                  </Button>
                  <Button asChild variant="outline" size="xl" className="bg-transparent border-white text-white hover:bg-white/10">
                    <Link to="/solutions">
                      Explore Solutions
                    </Link>
                  </Button>
                </div>
              </AnimateInView>
            </div>
          </div>
        </div>
      </section>
      
      {/* Second image below hero section */}
      <section className="w-full">
        
      </section>
    </>;
};
export default Hero;
